import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerWaveHeightListItem = (props) => {
    const { visualizerWaveScaleFactor, updateVisualizerSettings, maxWaveScaleFactor } = props;
    
    const onWaveHeightChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ waveScaleFactor: value });
    };
    
    return (
        <SliderListItem
            title='Wave Height'
            value={visualizerWaveScaleFactor}
            displayMultiplier={100 / maxWaveScaleFactor}
            min={0}
            max={100}
            step={1}
            onValueChange={onWaveHeightChange}
        />
        
    );
};

const mapStateToProps = (state) => {
    const { waveScaleFactor: visualizerWaveScaleFactor } = state.createPreview.present.videoSettings.visualizer;
    const { maxWaveScaleFactor } = state.create.maxValues;

    return { 
        visualizerWaveScaleFactor,
        maxWaveScaleFactor
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerWaveHeightListItem);